module.exports = __webpack_public_path__ + "static/media/edit-with-bg-grey.a19c4797.svg";